<template>
  <div class="contain flavor">
    <button class="btn text-btn" @click="$emit('show-page')">RETURN HOME</button>
    <h2>{{flavor.name}}</h2>
    <div class="details">
      <div class="image" :style="{backgroundImage: `url(${flavor.image})`}"></div>
      <div class="textbox">
        <div v-html="flavor.description"></div>
      </div>
    </div>
    <button class="btn smell">INITIATE SMELL</button>
  </div>
</template>

<script>
export default {
  props: ["flavor"]
};
</script>

<style lang='scss'>
.flavor {
  padding: 100px 200px;
  h2 {
    margin-bottom: 75px;
  }
  .image {
    height: 300px;
    width: 300px;
    margin-right: 75px;
    background-size: cover;
    flex: none;
  }
  .details {
    display: flex;
    align-items: flex-start;
    margin-top: 30px;
    margin-bottom: 30px;
    .textbox {
      font-size: 22px;
      h2 {
        font-size: 40px;
        margin-bottom: 20px;
        margin-top: 40px;
      }
      h3 {
        font-size: 30px;
        margin-bottom: 20px;
        margin-top: 40px;
      }
      h4 {
        font-size: 25px;
        margin-bottom: 20px;
        margin-top: 40px;
      }
    }
    & > div {
      &h2:first-child,
      &h3:first-child,
      &h4:first-child {
        margin-top: 0;
      }
    }
  }
  .btn.smell {
    margin-left: 375px;
  }
}
</style>